import {
  Component,
  OnInit,Input
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { formatDate } from '@angular/common';
import { ModalController,LoadingController } from '@ionic/angular';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-order-status-update',
  templateUrl: './order-status-update.component.html',
  styleUrls: ['./order-status-update.component.scss'],
})
export class OrderStatusUpdateComponent implements OnInit {

  focus:any={};
  today_date;
  submitted = false;
  error_msg = false;
  status;
  inprocess_form:any = FormGroup;
  @Input() order_detail;
  @Input() updated_status;

  constructor(public loadingController: LoadingController,public modalCtrl: ModalController,public formbuilder:FormBuilder,public db:DataService) { }

  ngOnInit() {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    this.today_date = formatDate(d, 'yyyy-MM-dd', 'en-US');
  
    this.inprocess_form = this.formbuilder.group({
      ship_date: new FormControl('', Validators.required),
      delivery_date: new FormControl('', Validators.required)
    })
  }

  
  get ship_date(){
    return this.inprocess_form.get('ship_date');
  } 
  
  get delivery_date(){
    return this.inprocess_form.get('delivery_date');
  } 

  cancle(){
    this.modalCtrl.dismiss();
  }

  save(){
    this.submitted = true;
    
    if(this.inprocess_form.valid) {
        if(this.inprocess_form.value.ship_date > this.inprocess_form.value.delivery_date){
          this.error_msg = true;
            // this.db.alert('Delivery Date should greater than the Ship Date.');
            this.status = 'Delivery Date should greater than the Ship Date.';
          setTimeout(()=>{this.error_msg = false},2500)
        }else{
          this.error_msg = false;
          this.update_value();
        }
    }
  }


  async update_value(){
    const loading = await this.loadingController.create({
      message: 'please wait...',
      duration: 2000
    });
    await loading.present(); 
    let data ={
      ship_date:this.inprocess_form.value.ship_date,
      delivery_date: this.inprocess_form.value.delivery_date,
      order_id: this.order_detail.name,
      doctype: 'Vendor Orders'
    }
    this.db.update_in_process_status(data).subscribe(res=>{
     if(res['message'] && res['message'].status == 'success'){
      // loading.onDidDismiss();
      this.db.added_animate.next('Order '+this.updated_status+' successfully');
      this.UpdateStatus(this.order_detail,this.updated_status);
      this.modalCtrl.dismiss();
     }
      
    })
  }



  UpdateStatus(item,status){
    this.db.Update_doc({status:status,name:item.name,doctype: "Order"}).subscribe(data => {
      //  console.log(data)
        this.order_detail.status = status;
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

}

